import { z } from 'zod';

export const storyScrollytellingSchema = z.object({
  eyebrow: z.string().max(120).optional(),
  title: z.string().min(1).max(200),
  titleHl: z.string().max(160).optional(),
  subtitle: z.string().max(500).optional(),
  linkLabel: z.string().max(80).optional(),
  linkHref: z.string().max(500).optional(),
  videoPoster: z.string().min(1).max(1000),
  videoPosterFallback: z.string().min(1).max(1000).optional(),
  videoAlt: z.string().max(200).optional(),
  videoCaption: z.object({
    title: z.string().min(1).max(160),
    sub: z.string().max(200),
  }),
  chapters: z
    .array(
      z.object({
        badge: z.string().min(1).max(80),
        eyebrow: z.string().min(1).max(120),
        bigValue: z.string().min(1).max(60),
        bigUnit: z.string().max(40).optional(),
        title: z.string().min(1).max(200),
        description: z.string().max(600),
        meta: z.array(z.string().max(80)).max(4).optional(),
      }),
    )
    .min(2)
    .max(6),
});

export type StoryScrollytellingData = z.infer<typeof storyScrollytellingSchema>;
